import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import MediaNotificationCommand from './medianotificationcommand';

export default class MediaNotification extends Plugin {
  static get pluginName() {
    return 'MediaNotification';
  }

  static get requires() {
    return [ MediaNotificationCommand ];
  }
}
